export const DEFAULT_MESSAGE_PREFIX = '[SberLead] ';

export const DEFAULT_LOGGING_LEVEL = 2;
